/* Fragrance Load Calculator — client-side, no dependencies.
 *
 * Data model (see docs/FRAGRANCE-CALCULATOR-DESIGN.md):
 *   - Shared config (project types + Low/Med/High + ifra_category, IFRA categories) from the
 *     pjt.calculator_config shop metafield, rendered INLINE by Liquid into
 *     <script type="application/json" data-fcalc-config>.
 *   - Fragrance {name, sg, level 1-10, ifra:{category:max}}:
 *       PDP:        data-scent-name / data-sg / data-level / data-ifra attributes (current product).
 *       Standalone: fetched from pj-fragrance-data.json ({scent_code:{name,sg,level,ifra}}).
 *
 * Load selection is a horizontal bar (low -> high). Circles = Low / Medium / High / P&J
 * Recommended (interpolated), each selectable. A red IFRA-limit marker caps the bar; markers to
 * its right are disabled. Recommended% = load_low + ((L-1)/9)*(load_high-load_low).
 */
(function () {
  "use strict";

  var G_PER = { g: 1, kg: 1000, oz: 28.349523, lb: 453.59237 };
  var G_PER_OZ_WT = 28.349523;
  var ML_PER_FL_OZ = 29.573530;

  function recommendedPct(level, low, high) {
    var L = Math.max(1, Math.min(10, level));
    return low + ((L - 1) / 9) * (high - low);
  }

  function calculate(projectGrams, loadPct, sg) {
    var foGrams = projectGrams * (loadPct / 100);
    var r = { foGrams: foGrams, foOzWt: foGrams / G_PER_OZ_WT, foMl: null, foFlOz: null };
    if (sg && sg > 0) { var ml = foGrams / sg; r.foMl = ml; r.foFlOz = ml / ML_PER_FL_OZ; }
    return r;
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) throw new Error("Failed to load " + url + " (" + res.status + ")");
      return res.json();
    });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") node.className = attrs[k];
      else if (k === "text") node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { node.appendChild(c); });
    return node;
  }

  function round(n, dp) { var f = Math.pow(10, dp == null ? 2 : dp); return Math.round(n * f) / f; }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }
  function parseIfra(s) { try { return s ? JSON.parse(s) : {}; } catch (e) { return {}; } }

  function ifraMaxFor(pt, frag) {
    if (!pt || !pt.ifra_category || !frag || !frag.ifra) return null;
    var m = frag.ifra[pt.ifra_category];
    return isFinite(m) ? +m : null;
  }

  // ---- PDP purchase recommendation (based on the volume result) ----
  // Parse a size label ("100ml", "16FlOz", "30ML") into millilitres.
  function parseVolumeMl(s) {
    if (!s) return null;
    var m = String(s).toLowerCase().match(/([\d.]+)\s*(ml|l|fl\s*oz|floz|oz)\b/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (!isFinite(n)) return null;
    var u = m[2].replace(/\s+/g, "");
    if (u === "ml") return n;
    if (u === "l") return n * 1000;
    return n * ML_PER_FL_OZ;   // floz / fl oz / oz — these products are sold by volume
  }
  // Normalize Shopify variant objects (from inline JSON or /products/{handle}.js — both give price in
  // cents) -> [{id, title, ml, priceCents, available}], keeping only sizes we can read a volume from.
  function mapVariants(arr) {
    return (arr || []).map(function (v) {
      return { id: v.id, title: v.title,
               ml: parseVolumeMl(v.title) || parseVolumeMl(v.option1),
               priceCents: typeof v.price === "number" ? v.price : parseInt(v.price, 10),
               available: v.available !== false };
    }).filter(function (v) { return v.ml && v.ml > 0; });
  }
  // Read the PDP's variants (inline JSON, emitted by the section).
  function readVariants(container) {
    var s = container.querySelector('script[type="application/json"][data-fcalc-variants]');
    if (!s) return [];
    var arr;
    try { arr = JSON.parse(s.textContent) || []; } catch (e) { return []; }
    return mapVariants(arr);
  }
  // Standalone: fetch a selected product's live variants via the public Ajax endpoint (no auth).
  function fetchVariants(handle) {
    return fetchJSON("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (p) { return mapVariants(p.variants || []); });
  }
  // Most cost-effective purchase: the min-cost combination of sizes (mixing allowed) whose total
  // volume covers the need. DP over integer millilitres — cost[v] = cheapest way to reach >= v.
  // Returns { items:[{v,qty}], totalCents, volumeMl } or null.
  var RECO_CAP_ML = 50000;
  function recommendPurchase(neededMl, variants) {
    var priced = (variants || []).filter(function (v) { return v.available && v.ml > 0 && isFinite(v.priceCents) && v.priceCents > 0; });
    if (!neededMl || neededMl <= 0) return null;
    var need = Math.ceil(neededMl);
    if (!priced.length || need > RECO_CAP_ML) return fallbackSingle(neededMl, variants);

    var sizes = priced.map(function (v) { return { v: v, ml: Math.max(1, Math.round(v.ml)), price: v.priceCents }; });
    var cost = new Array(need + 1), pick = new Array(need + 1);
    cost[0] = 0;
    for (var v = 1; v <= need; v++) {
      cost[v] = Infinity;
      for (var i = 0; i < sizes.length; i++) {
        var c = sizes[i].price + cost[Math.max(0, v - sizes[i].ml)];
        if (c < cost[v]) { cost[v] = c; pick[v] = i; }
      }
    }
    var counts = {};
    for (var vv = need; vv > 0;) { var k = pick[vv]; counts[k] = (counts[k] || 0) + 1; vv = Math.max(0, vv - sizes[k].ml); }
    var items = Object.keys(counts).map(function (key) { return { v: sizes[+key].v, qty: counts[key] }; });
    items.sort(function (a, b) { return b.v.ml - a.v.ml; });
    return {
      items: items,
      totalCents: items.reduce(function (s, it) { return s + it.qty * it.v.priceCents; }, 0),
      volumeMl: items.reduce(function (s, it) { return s + it.qty * it.v.ml; }, 0),
    };
  }
  // Fallback when no priced variants (or an oversized order): single size, fewest units then least waste.
  function fallbackSingle(neededMl, variants) {
    var avail = (variants || []).filter(function (v) { return v.available && v.ml > 0; });
    if (!neededMl || neededMl <= 0 || !avail.length) return null;
    var best = null;
    avail.forEach(function (v) {
      var qty = Math.ceil(neededMl / v.ml);
      var cand = { v: v, qty: qty, waste: qty * v.ml - neededMl };
      if (!best || cand.qty < best.qty || (cand.qty === best.qty && cand.waste < best.waste)) best = cand;
    });
    return { items: [{ v: best.v, qty: best.qty }],
             totalCents: isFinite(best.v.priceCents) ? best.qty * best.v.priceCents : NaN,
             volumeMl: best.qty * best.v.ml };
  }
  function money(cents) { return isFinite(cents) ? "$" + (cents / 100).toFixed(2) : ""; }

  // Fire add-to-cart attribution to whatever analytics tools are present (all guarded).
  // Custom params are ALL prefixed pj_ on purpose: bare `source` collides with GA4's own traffic
  // attribution (source/medium/campaign), and `load`/`project`/`weight` are generic enough to clash
  // with anything else writing to the same property or dataLayer. Prefix matches the _pj_* line-item
  // properties. Renaming these breaks GA4 custom dimensions + GTM variables — see docs/web-pixel.md.
  function fireAddToCartAnalytics(meta) {
    var payload = {
      pj_surface: meta.surface, currency: "USD", value: meta.value,
      items: meta.items,
      pj_load: meta.load, pj_project: meta.project, pj_weight: meta.weight, pj_volume_ml: meta.volumeMl,
    };
    try { if (typeof window.gtag === "function") window.gtag("event", "add_to_cart", payload); } catch (e) {}
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(assign({ event: "add_to_cart" }, payload)); } catch (e) {}
    try {
      if (typeof window.fbq === "function") window.fbq("track", "AddToCart", {
        content_type: "product", value: meta.value, currency: "USD",
        contents: meta.items.map(function (it) { return { id: it.item_id, quantity: it.quantity }; }),
      });
    } catch (e) {}
    // custom DOM event any GTM / listener on the storefront window can subscribe to
    try { document.dispatchEvent(new CustomEvent("fragrance_calculator:add_to_cart", { bubbles: true, detail: payload })); } catch (e) {}
    // publish into Shopify's analytics bus so a custom Web Pixel can subscribe (see docs/web-pixel.md)
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function")
        window.Shopify.analytics.publish("fragrance_calculator_add_to_cart", payload);
    } catch (e) {}
  }
  function assign(a, b) { for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k]; return a; }

  // Is the UpCart drawer app actually mounted and enabled on this page?
  // NOT `typeof window.upcartRegisterAddToCart === "function"` — UpCart assigns a no-op stub for
  // that on script load and only wires the real one later, so the stub would pass and we'd
  // suppress the redirect while nothing opens. These two are set only once its cart is enabled.
  function upcartEnabled() {
    return document.body.getAttribute("data-upcart-cart-enabled") === "true" &&
           !!document.getElementById("upCart");
  }

  // Show the cart after a successful add. UpCart present => it owns the drawer and we must NOT
  // navigate; otherwise fall back to the theme's drawer toggle, then to /cart.
  function showCart(container) {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
    } catch (e) {}
    if (upcartEnabled()) {
      // zero-arg notification: "something was added" -> UpCart refreshes + opens. Never navigate.
      try { if (typeof window.upcartRegisterAddToCart === "function") window.upcartRegisterAddToCart(); } catch (e) {}
      return;
    }
    var sel = container.getAttribute("data-cart-drawer-selector");
    if (sel) {
      var toggle = document.querySelector(sel);
      if (toggle) { try { toggle.click(); return; } catch (e) {} }
    }
    window.location.href = "/cart";
  }

  // One add may be in flight at a time; guards against double-clicks adding twice.
  var adding = false;

  // AJAX add with line-item properties (attribution persists onto the order), then show the cart.
  // A single POST with an items[] array is the only way to add several variants with per-line
  // properties atomically — UpCart cannot do this (its form path keeps one id, and its public
  // add hook takes no arguments), so we always own the add and UpCart only owns the UI.
  function addToCart(items, meta, container, btn) {
    if (adding) return;
    adding = true;
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); btn.textContent = "Adding…"; }
    function done(restore) {
      adding = false;
      if (btn && restore) { btn.disabled = false; btn.removeAttribute("aria-busy"); btn.textContent = "Add to Cart"; }
    }
    fireAddToCartAnalytics(meta);
    fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) throw new Error("cart/add failed (" + res.status + ")");
      // Leave the button disabled when we're navigating away; re-enable when we're staying put.
      done(upcartEnabled() || !!container.getAttribute("data-cart-drawer-selector"));
      showCart(container);
    }).catch(function () { done(true); window.location.href = "/cart"; });
  }

  // Load markers for the bar (selectable). P&J Recommended only when the fragrance has a level.
  function markersFor(pt, frag) {
    var arr = [
      { key: "low", label: "Low", pct: pt.low },
      { key: "medium", label: "Medium", pct: pt.medium },
      { key: "high", label: "High", pct: pt.high },
    ];
    if (frag && frag.level != null && isFinite(frag.level)) {
      arr.push({ key: "recommended", label: "P&J Recommended", pct: recommendedPct(frag.level, pt.low, pt.high), rec: true });
    }
    return arr;
  }

  function posOf(pct, pt) {
    var span = pt.high - pt.low;
    if (span <= 0) return 0;
    return Math.max(0, Math.min(1, (pct - pt.low) / span));
  }

  function readConfig(container) {
    var s = container.querySelector('script[type="application/json"][data-fcalc-config]');
    var cfg = {};
    if (s) { try { cfg = JSON.parse(s.textContent) || {}; } catch (e) { if (window.console) console.error(e); } }
    var pts = (cfg.project_types || []).map(function (p) {
      return { name: p.name, short_name: p.short_name || p.name, description: p.description || "",
               low: +p.low, medium: +p.medium, high: +p.high, ifra_category: p.ifra_category || "",
               parent: p.parent || "" };
    });
    return { projectTypes: pts, ifraCategories: cfg.ifra_categories || {} };
  }

  function init(container) {
    var projectTypes = readConfig(container).projectTypes;
    var variants = readVariants(container);                             // PDP: current product's size variants
    var fixedName = container.getAttribute("data-scent-name") || null;  // PDP: current product's scent
    var dataUrl = container.getAttribute("data-data-url");              // standalone

    if (!projectTypes.length) { container.textContent = "No project types are configured yet."; return; }

    if (fixedName) {
      // req 4: default to the current fragrance-oil page's scent
      var frag = { name: fixedName, sg: num(container.getAttribute("data-sg")),
                   level: num(container.getAttribute("data-level")), ifra: parseIfra(container.getAttribute("data-ifra")) };
      render(container, projectTypes, null, frag, variants);
    } else if (dataUrl) {
      fetchJSON(dataUrl)
        .then(function (data) { render(container, projectTypes, data, null, variants); })
        .catch(function (err) { container.textContent = "Sorry, the calculator could not load its data."; if (window.console) console.error(err); });
    } else {
      container.textContent = "Calculator is misconfigured.";
    }
  }

  function render(container, projectTypes, data, fixedFragrance, variants) {
    container.innerHTML = "";
    var state = { pt: projectTypes[0], frag: fixedFragrance, loadPct: null, weight: null, unit: "lb" };

    var form = el("form", { class: "fcalc__form", novalidate: "novalidate" });

    // Fragrance — on the PDP it's the current product (shown in the page heading + summary),
    // so no redundant Fragrance field is rendered. Standalone shows a picker.
    if (!fixedFragrance) {
      var codes = Object.keys(data).sort(function (a, b) { return (data[a].name || a).localeCompare(data[b].name || b); });
      var scentSel = el("select", { class: "fcalc__scent", "aria-label": "Fragrance" },
        [el("option", { value: "", text: "Select a fragrance…" })].concat(codes.map(function (c) {
          return el("option", { value: c, text: data[c].name || c });
        })));
      scentSel.addEventListener("change", function () {
        state.frag = this.value ? data[this.value] : null;
        state.loadPct = null;
        refresh();
        // pull live variants for the purchase recommendation (cached on the fragrance object)
        var f = state.frag;
        if (f && f.handle && !f.variants) {
          fetchVariants(f.handle)
            .then(function (vs) { f.variants = vs; if (state.frag === f) update(); })
            .catch(function () { /* no recommendation if the product feed is unavailable */ });
        }
      });
      form.appendChild(field("Fragrance", scentSel));
    }

    // Project type — top-level leaves render as buttons; grouped types render as a 2-line dropdown
    // (line 1 = parent, line 2 = selected child). Fills horizontally, then wraps. Above project weight.
    var ptGroup = el("div", { class: "fcalc__pt-group", role: "group", "aria-label": "Project type" });

    // Slots = top-level leaves + groups, sorted alphabetically by their displayed name (leaves and
    // groups interleaved); each group's children are also sorted alphabetically. Groups aren't selectable.
    function ptSlots() {
      var slots = [], gi = {};
      projectTypes.forEach(function (p) {
        if (!p.parent) { slots.push({ type: "leaf", pt: p }); return; }
        if (gi[p.parent] == null) { gi[p.parent] = slots.length; slots.push({ type: "group", name: p.parent, children: [] }); }
        slots[gi[p.parent]].children.push(p);
      });
      var opts = { sensitivity: "base" };
      function label(s) { return (s.type === "leaf" ? (s.pt.short_name || s.pt.name) : s.name) || ""; }
      slots.sort(function (a, b) { return label(a).localeCompare(label(b), undefined, opts); });
      slots.forEach(function (s) {
        if (s.type === "group") s.children.sort(function (a, b) {
          return (a.short_name || a.name || "").localeCompare(b.short_name || b.name || "", undefined, opts);
        });
      });
      return slots;
    }
    // Default selection = the alphabetically-first selectable leaf (a top-level button first; if the
    // display is all groups, the first group's first child).
    function defaultLeaf() {
      var slots = ptSlots();
      for (var i = 0; i < slots.length; i++) if (slots[i].type === "leaf") return slots[i].pt;
      for (var j = 0; j < slots.length; j++) if (slots[j].children && slots[j].children.length) return slots[j].children[0];
      return projectTypes[0];
    }
    function selectPt(p) { state.pt = p; state.loadPct = null; renderPtControls(); refresh(); }

    function renderPtControls() {
      ptGroup.innerHTML = "";
      ptSlots().forEach(function (slot) {
        if (slot.type === "leaf") {
          var b = el("button", { type: "button",
            class: "fcalc__pt-btn" + (state.pt === slot.pt ? " is-selected" : ""),
            title: slot.pt.description, "aria-pressed": state.pt === slot.pt ? "true" : "false", text: slot.pt.short_name });
          b.addEventListener("click", function () { selectPt(slot.pt); });
          ptGroup.appendChild(b);
          return;
        }
        // group: custom 2-line dropdown (parent name + selected child)
        var active = slot.children.indexOf(state.pt) >= 0 ? state.pt : null;
        var ctrl = el("div", { class: "fcalc__pt-drop" + (active ? " is-selected" : ""),
          role: "button", tabindex: "0", "aria-haspopup": "listbox", "aria-expanded": "false" }, [
          el("span", { class: "fcalc__pt-parent", text: slot.name }),
          el("span", { class: "fcalc__pt-child", text: active ? active.short_name : "" }),
        ]);
        var menu = el("div", { class: "fcalc__pt-menu", role: "listbox" });
        slot.children.forEach(function (c) {
          var o = el("button", { type: "button", role: "option",
            class: "fcalc__pt-opt" + (state.pt === c ? " is-selected" : ""), title: c.description, text: c.short_name });
          o.addEventListener("click", function (e) { e.stopPropagation(); selectPt(c); });
          menu.appendChild(o);
        });
        ctrl.appendChild(menu);
        function toggle() {
          ctrl.classList.toggle("is-open");
          ctrl.setAttribute("aria-expanded", ctrl.classList.contains("is-open") ? "true" : "false");
        }
        ctrl.addEventListener("click", toggle);
        ctrl.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); }
          else if (e.key === "Escape") { ctrl.classList.remove("is-open"); ctrl.setAttribute("aria-expanded", "false"); }
        });
        ptGroup.appendChild(ctrl);
      });
      fitPtButtons();
    }

    // Shrink a label's font ONLY when it actually overflows its box (a small tolerance keeps
    // borderline labels like "Body Scrub" at full size unless they'd overlap the arrow/edge).
    function fitPtButtons() {
      Array.prototype.forEach.call(ptGroup.querySelectorAll(".fcalc__pt-btn, .fcalc__pt-child"), function (b) {
        b.style.fontSize = "";
        var size = parseFloat((window.getComputedStyle && getComputedStyle(b).fontSize) || "18") || 18;
        while (size > 11 && (b.scrollHeight > b.clientHeight + 1 || b.scrollWidth > b.clientWidth + 2)) {
          size -= 1;
          b.style.fontSize = size + "px";
        }
      });
    }

    // close any open group dropdown when clicking outside it
    document.addEventListener("click", function (e) {
      Array.prototype.forEach.call(ptGroup.querySelectorAll(".fcalc__pt-drop.is-open"), function (d) {
        if (!d.contains(e.target)) { d.classList.remove("is-open"); d.setAttribute("aria-expanded", "false"); }
      });
    });

    state.pt = defaultLeaf();
    renderPtControls();
    form.appendChild(el("div", { class: "fcalc__field" }, [el("span", { class: "fcalc__label", text: "Project Type" }), ptGroup]));

    // Project weight + unit
    var weightInput = el("input", { class: "fcalc__weight", type: "number", min: "0", step: "any", placeholder: "e.g. 5", inputmode: "decimal" });
    var unitSel = el("select", { class: "fcalc__unit", "aria-label": "Unit" },
      ["lb", "oz", "kg", "g"].map(function (u) { return el("option", { value: u, text: u }); }));
    weightInput.addEventListener("input", function () { state.weight = parseFloat(this.value); update(); });
    unitSel.addEventListener("change", function () { state.unit = this.value; update(); });
    form.appendChild(field("Project Weight", el("div", { class: "fcalc__weight-row" }, [weightInput, unitSel])));

    // Load selection bar (a div, not a <label> — the bar contains buttons)
    var barWrap = el("div", { class: "fcalc__bar-wrap" });
    var barCaption = el("div", { class: "fcalc__bar-caption", text: "Fragrance Load %" });
    form.appendChild(el("div", { class: "fcalc__field" },
      [el("span", { class: "fcalc__label", text: "Scent Throw Recommendation" }), barWrap, barCaption]));

    var results = el("div", { class: "fcalc__results", "aria-live": "polite" });
    container.appendChild(form);
    container.appendChild(results);
    fitPtButtons();  // now in the DOM — size the labels to fit
    window.addEventListener("resize", function () {
      clearTimeout(state._fitTimer);
      state._fitTimer = setTimeout(fitPtButtons, 150);
    });

    // ---- Load bar: preset quick-selects (Low/Medium/High/Recommended + IFRA Limit) plus a
    //      draggable handle that can rest at any point along the bar. ----
    function capOf() { return ifraMaxFor(state.pt, state.frag); }
    function maxPct() { var c = capOf(); return c != null ? Math.min(state.pt.high, c) : state.pt.high; }
    function clampPct(p) { return Math.max(state.pt.low, Math.min(maxPct(), p)); }
    function recPct() {
      return (state.frag && state.frag.level != null && isFinite(state.frag.level))
        ? recommendedPct(state.frag.level, state.pt.low, state.pt.high) : null;
    }
    function defaultLoadPct() {
      var c = capOf(), r = recPct();
      if (r != null && (c == null || r <= c + 1e-9)) return r;
      if (c == null || state.pt.medium <= c + 1e-9) return state.pt.medium;
      return maxPct();
    }
    // snap targets = selectable presets + the IFRA cap (if it falls inside the bar)
    function snapTargets() {
      var c = capOf(), out = [];
      markersFor(state.pt, state.frag).forEach(function (m) { if (c == null || m.pct <= c + 1e-9) out.push(m.pct); });
      if (c != null && c > state.pt.low && c < state.pt.high) out.push(c);
      return out;
    }
    function snap(pct) {
      var span = state.pt.high - state.pt.low, thresh = span * 0.03, best = pct, bd = thresh;
      snapTargets().forEach(function (t) { var d = Math.abs(t - pct); if (d <= bd) { bd = d; best = t; } });
      return best;
    }

    var handleEl = null, handleValEl = null, trackEl = null, dragging = false;
    function positionHandle() {
      if (!handleEl) return;
      handleEl.style.left = (posOf(state.loadPct, state.pt) * 100) + "%";
      handleEl.setAttribute("aria-valuenow", String(round(state.loadPct, 2)));
      if (handleValEl) handleValEl.textContent = round(state.loadPct, 2) + "%";
    }
    function setLoad(pct) { state.loadPct = clampPct(pct); positionHandle(); update(); }
    function pctFromClientX(clientX) {
      if (!trackEl) return state.loadPct;
      var rect = trackEl.getBoundingClientRect();
      if (rect.width <= 0) return state.loadPct;
      var pos = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      return snap(clampPct(state.pt.low + pos * (state.pt.high - state.pt.low)));
    }
    // document-level move/up so a drag continues even if the pointer leaves the handle
    document.addEventListener("pointermove", function (e) { if (dragging) setLoad(pctFromClientX(e.clientX)); });
    document.addEventListener("pointerup", function () { dragging = false; });

    function renderBar() {
      barWrap.innerHTML = "";
      var pt = state.pt, cap = capOf();
      var bar = el("div", { class: "fcalc__bar" });

      var track = el("div", { class: "fcalc__track" });
      if (cap != null && cap < pt.high) {
        var capPos = posOf(cap, pt) * 100;
        track.appendChild(el("div", { class: "fcalc__track-avail", style: "width:" + capPos + "%" }));
        track.appendChild(el("div", { class: "fcalc__track-capped", style: "left:" + capPos + "%;width:" + (100 - capPos) + "%" }));
      } else {
        track.appendChild(el("div", { class: "fcalc__track-avail", style: "width:100%" }));
      }
      track.addEventListener("pointerdown", function (e) { dragging = true; setLoad(pctFromClientX(e.clientX)); e.preventDefault(); });
      bar.appendChild(track);
      trackEl = track;

      // preset quick-selects
      markersFor(pt, state.frag).forEach(function (m) {
        var pos = posOf(m.pct, pt) * 100;
        var disabled = cap != null && m.pct > cap + 1e-9;
        var col = el("div", { class: "fcalc__mk" + (m.rec ? " is-rec" : "") + (disabled ? " is-disabled" : ""), style: "left:" + pos + "%" });
        var lbl = el("button", { type: "button", class: "fcalc__mk-label", text: m.label });
        var dot = el("button", { type: "button", class: "fcalc__mk-dot", "aria-label": m.label + " " + round(m.pct, 2) + "%" });
        if (disabled) { lbl.disabled = true; dot.disabled = true; }
        else {
          lbl.addEventListener("click", function () { setLoad(m.pct); });
          dot.addEventListener("click", function () { setLoad(m.pct); });
        }
        col.appendChild(lbl);
        col.appendChild(el("span", { class: "fcalc__mk-line" }));
        col.appendChild(dot);
        col.appendChild(el("span", { class: "fcalc__mk-pct", text: round(m.pct, 2) + "%" }));
        bar.appendChild(col);
      });

      // IFRA limit — a selectable position (not just a visual marker)
      if (cap != null && cap > pt.low && cap < pt.high) {
        var ipos = posOf(cap, pt) * 100;
        var icol = el("div", { class: "fcalc__mk fcalc__mk--ifra", style: "left:" + ipos + "%" });
        var ilbl = el("button", { type: "button", class: "fcalc__mk-label fcalc__mk-label--ifra", text: "IFRA Limit" });
        var idot = el("button", { type: "button", class: "fcalc__mk-dot fcalc__mk-dot--ifra", "aria-label": "IFRA limit " + round(cap, 2) + "%" });
        ilbl.addEventListener("click", function () { setLoad(cap); });
        idot.addEventListener("click", function () { setLoad(cap); });
        icol.appendChild(ilbl);
        icol.appendChild(el("span", { class: "fcalc__mk-line fcalc__mk-line--ifra" }));
        icol.appendChild(idot);
        icol.appendChild(el("span", { class: "fcalc__mk-pct fcalc__mk-pct--ifra", text: round(cap, 2) + "%" }));
        bar.appendChild(icol);
      }

      // draggable handle (the positional selector)
      handleEl = el("button", { type: "button", class: "fcalc__handle", role: "slider",
        "aria-label": "Fragrance load", "aria-valuemin": String(round(pt.low, 2)), "aria-valuemax": String(round(maxPct(), 2)) });
      handleEl.addEventListener("pointerdown", function (e) { dragging = true; e.preventDefault(); });
      handleEl.addEventListener("keydown", function (e) {
        var step = (pt.high - pt.low) / 50;  // ~2% of the range per keypress
        if (e.key === "ArrowRight" || e.key === "ArrowUp") { setLoad(state.loadPct + step); e.preventDefault(); }
        else if (e.key === "ArrowLeft" || e.key === "ArrowDown") { setLoad(state.loadPct - step); e.preventDefault(); }
        else if (e.key === "Home") { setLoad(pt.low); e.preventDefault(); }
        else if (e.key === "End") { setLoad(maxPct()); e.preventDefault(); }
      });
      handleValEl = el("span", { class: "fcalc__handle-val" });   // live % readout, styled like preset values
      handleEl.appendChild(handleValEl);
      bar.appendChild(handleEl);

      barWrap.appendChild(bar);
      positionHandle();
    }

    function refresh() {
      if (state.frag) {
        state.loadPct = (state.loadPct == null) ? defaultLoadPct() : clampPct(state.loadPct);
        renderBar();
      } else {
        barWrap.innerHTML = "";
        handleEl = null; handleValEl = null; trackEl = null;
      }
      update();
    }

    function update() {
      results.innerHTML = "";
      if (!state.frag) { results.appendChild(el("p", { class: "fcalc__hint", text: "Select a fragrance to begin." })); return; }

      var loadPct = state.loadPct;
      var sg = state.frag.sg;
      var cap = capOf();

      if (loadPct == null) {
        results.appendChild(el("p", { class: "fcalc__hint", text: "Select a load level to see how much to add." }));
        return;
      }

      var grams = isFinite(state.weight) && state.weight > 0 ? state.weight * G_PER[state.unit] : null;
      var r = grams != null ? calculate(grams, loadPct, sg) : null;

      // Summary
      results.appendChild(el("p", { class: "fcalc__summary", text: state.frag.name + " Amounts Needed" }));

      // Amount table (above specific gravity); numbers fill in once a weight is entered
      results.appendChild(el("table", { class: "fcalc__table" }, [
        el("thead", {}, [rowEls("th", ["", "Metric", "Imperial"])]),
        el("tbody", {}, [
          rowEls("td", ["Weight", r ? round(r.foGrams) + " g" : "—", r ? round(r.foOzWt) + " oz wt" : "—"]),
          (r && r.foMl != null) ? rowEls("td", ["Volume", round(r.foMl) + " mL", round(r.foFlOz) + " fl oz"])
                                : rowEls("td", ["Volume", "—", "—"]),
        ]),
      ]));
      if (r && r.foMl == null) {
        results.appendChild(el("p", { class: "fcalc__note", text: "Volume unavailable — no specific gravity on file for this fragrance." }));
      }

      // Specific Gravity (now below the table)
      results.appendChild(labeled("Specific Gravity:", sg != null ? String(sg) : "—"));

      // IFRA category — red only when the selected load has reached the IFRA limit; grey/italic otherwise.
      if (state.pt.ifra_category) {
        var ifraRed = cap != null && loadPct >= cap - 1e-9;
        results.appendChild(labeled("IFRA Category " + state.pt.ifra_category + ":",
          cap != null ? "max " + round(cap, 2) + "%" : "no limit on file",
          ifraRed ? "fcalc__detail--ifra" : ""));
      }

      // Purchase recommendation — most cost-effective combination that covers the volume result.
      // PDP: inline variants; standalone: variants fetched for the selected product.
      var recoVariants = (state.frag && state.frag.variants) ? state.frag.variants : variants;
      if (recoVariants && recoVariants.length && r && r.foMl != null) {
        var reco = recommendPurchase(r.foMl, recoVariants);
        if (reco && reco.items.length) {
          var desc = reco.items.map(function (it) { return it.qty + "ea " + it.v.title; }).join(" + ");
          var priceStr = isFinite(reco.totalCents) ? " (" + money(reco.totalCents) + ")" : "";

          // line-item properties → attribution persists onto the order line
          var props = {
            "_pj_source": "Fragrance Load Calculator",
            "_pj_load": round(loadPct, 2) + "%",
            "_pj_project": state.pt.name,
            "_pj_weight": round(state.weight, 3) + " " + state.unit,
            "_pj_volume_ml": round(r.foMl, 1),
          };
          var items = reco.items.map(function (it) { return { id: it.v.id, quantity: it.qty, properties: props }; });
          var meta = {
            value: isFinite(reco.totalCents) ? reco.totalCents / 100 : undefined,
            // Which calculator fired this. PDP mode is the one with a fixed fragrance; standalone
            // lets the shopper pick. Its presence at all means "this add came from the calculator".
            surface: fixedFragrance ? "pdp" : "standalone",
            // GA4 ecommerce item shape — item_name/price are what make the Monetization reports
            // readable; without them GA4 shows "(not set)". Distinct from the cart `items` above.
            items: reco.items.map(function (it) {
              return { item_id: String(it.v.id), item_name: state.frag.name, item_variant: it.v.title,
                       price: isFinite(it.v.priceCents) ? it.v.priceCents / 100 : undefined,
                       quantity: it.qty };
            }),
            load: props._pj_load, project: props._pj_project, weight: props._pj_weight, volumeMl: props._pj_volume_ml };

          // A real <button>, NOT an <a href="/cart/{id}:{qty}"> permalink. That permalink both adds
          // the line AND navigates to the cart, so any third-party capture-phase click handler that
          // stops propagation before ours turns it into a second, untracked add. There is no no-JS
          // purchase path to preserve — the snippet's <noscript> already says the calculator needs JS.
          var btn = el("button", { type: "button", class: "fcalc__cart-btn", text: "Add to Cart" });
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(items, meta, container, btn);
          });

          results.appendChild(el("div", { class: "fcalc__reco" }, [
            el("p", { class: "fcalc__reco-line" }, [
              el("span", { class: "fcalc__detail-label", text: "Recommended purchase: " }),
              el("span", { text: desc + priceStr }),
            ]),
            btn,
          ]));
        }
      }
    }

    refresh();
  }

  function field(labelText, control) {
    return el("label", { class: "fcalc__field" }, [el("span", { class: "fcalc__label", text: labelText }), control]);
  }
  function rowEls(cellTag, values) {
    return el("tr", {}, values.map(function (v) { return el(cellTag, { text: String(v) }); }));
  }
  // a result detail line: bold Proper-Case label + normal value (optional extra class, e.g. --ifra)
  function labeled(label, value, cls) {
    return el("p", { class: "fcalc__detail" + (cls ? " " + cls : "") }, [
      el("span", { class: "fcalc__detail-label", text: label }),
      el("span", { text: " " + value }),
    ]);
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-fragrance-calculator]");
    Array.prototype.forEach.call(nodes, init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
